import numbroWithFailsafe from "./numbroWithFailsafe.js";

function percentage() {
	const defaultFormat = "0[.]00 %";

	const my = {};

	function that(number) {
		return my.format(number, defaultFormat);
	}

	that.forceTwoDecimals = function (number) {
		return my.format(number, "0.00 %");
	};

	that.absoluteValueTwoDecimals = function (number) {
		return that.forceTwoDecimals(Math.abs(number));
	};

	that.withNumberOfDecimals = function (numberOfDecimals) {
		const format = ",0[.]"
			.concat(new Array(numberOfDecimals + 1).join(0))
			.concat(" %");
		return (number) => my.format(number, format);
	};

	my.format = function (number, formatName) {
		return numbroWithFailsafe(number).format(formatName);
	};

	return that;
}

export default percentage();
